import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { Popover } from '@headlessui/react';

// Hooks
import useGetGlobalInfo from '@/utils/layout/globalInfoDisclaimer/useGetGlobalInfo';
import useSocialProfilesAuthStatus from '@/utils/hooks/swr/useSocialProfilesAuthStatus';

// Types
import { PopoverContainer, PopoverWrapper } from '@/components/base/Popover';

// Components
import Icon from '@/components/base/Icon';
const GlobalInfoDisclaimerPopover = dynamic(() =>
    import(
        '@/components/layouts/LayoutPlatform/components/Header/components/GlobalInfoDisclaimer/Popover'
    ).then((mod) => mod.GlobalInfoDisclaimerPopover)
);

export function GlobalInfoDisclaimer() {
    const { banners, nbActiveBanners, bannersType } = useGetGlobalInfo();

    // Launch the SWR to check the auth status of the social profiles
    useSocialProfilesAuthStatus();

    if (nbActiveBanners === 0) return null;

    return (
        <PopoverWrapper
            popperOptions={{
                placement: 'bottom-end',
                modifiers: [{ name: 'flip', options: { fallbackPlacements: ['auto'] } }]
            }}>
            {({ setReferenceElement, setPopperElement, styles, attributes }) => (
                <>
                    <Popover.Button
                        ref={setReferenceElement}
                        data-testid="global-info-disclaimer"
                        className={clsx(
                            'flex items-center gap-1 rounded-full p-1 text-white focus:ring-offset-0',
                            {
                                'bg-icoRed': bannersType === 'error',
                                'bg-icoBlue': bannersType === 'info'
                            }
                        )}>
                        <Icon icon="disconnect" />
                        <span
                            className={clsx(
                                'flex h-4 w-4 items-center justify-center rounded-full bg-white text-xxs',
                                {
                                    'text-icoRed': bannersType === 'error',
                                    'text-icoBlue': bannersType === 'info'
                                }
                            )}>
                            {nbActiveBanners}
                        </span>
                    </Popover.Button>
                    <PopoverContainer
                        setPopperElement={setPopperElement}
                        styles={styles}
                        attributes={attributes}>
                        <GlobalInfoDisclaimerPopover banners={banners} />
                    </PopoverContainer>
                </>
            )}
        </PopoverWrapper>
    );
}
